'use client';

import type { FC } from 'react';
import { Spinner } from './Spinner';

export const ScreenSkeleton: FC = () => (
  <div className="flex items-center justify-center h-full min-h-[200px]">
    <Spinner size="m" />
  </div>
);
